module.exports = __webpack_public_path__ + "img/hohlschnitt_signalgelb_ral1003.3c0966d3.jpg";